import { Reachability } from '@aws-amplify/core';
export var ReachabilityMonitor = function () { return new Reachability().networkMonitor(); };
//# sourceMappingURL=index.js.map